import { render, staticRenderFns } from "./quesRadio.vue?vue&type=template&id=858a7f08"
import script from "./quesRadio.vue?vue&type=script&lang=js"
export * from "./quesRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports